import PropTypes from "prop-types";

export const apartmentArrayType = PropTypes.arrayOf(PropTypes.shape({...apartmentType}));

export const apartmentType = {
    apartment_classification: PropTypes.string,
    apartment_name: PropTypes.string,
    apartment_picture: PropTypes.string,
    apartment_short_code: PropTypes.string,
    apartment_size: PropTypes.number,
    apartment_size_name: PropTypes.string,
    available: PropTypes.bool,
    contentful_entry_id: PropTypes.string,
    currency: PropTypes.string,
    differentiation1: PropTypes.string,
    differentiation2: PropTypes.string,
    differentiation3: PropTypes.string,
    extra_bed: PropTypes.bool,
    high_season_points: PropTypes.number,
    local_costs: PropTypes.number,
    low_season_points: PropTypes.number,
    max_number_of_guests: PropTypes.number,
    no_of_available_apartments: PropTypes.number,
    number_of_bathrooms: PropTypes.number,
    number_of_beds: PropTypes.number,
    number_of_rooms: PropTypes.number,
    total_points: PropTypes.number,
    trial_booking_costs: PropTypes.number,
    wheelchair_accessibility: PropTypes.bool
};